import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'large';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 无删减韩国漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3">
          <p className="text-white text-xs leading-relaxed line-clamp-3">{comic.shortDescription}</p>
        </div>
        {comic.status === '连载中' && (
          <div className="absolute top-2 left-2">
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              连载中
            </span>
          </div>
        )}
        {comic.status === '已完结' && (
          <div className="absolute top-2 left-2">
            <span className="px-2 py-0.5 bg-foreground-600 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              已完结
            </span>
          </div>
        )}
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <div className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-accent-500 font-medium">{comic.rating}</span>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-1">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}